import {Component, Input, OnInit} from '@angular/core';
import {CommonService} from '../../services/common.service';
import {CompanyService} from '../../services/company.service';
import {Subscription as RxSubscription} from 'rxjs';
import {UserService} from '../../services/user.service';
import {ListingService} from '../../services/listing.service';

@Component({
    selector: 'company-component',
    templateUrl: 'app.component.html',
    styleUrl: 'app.component.scss',
    standalone: false
})
export class CompanyComponent implements OnInit {
  public company;
  private Subscriptions: RxSubscription[] = [];
  public user;
  public loading: boolean;
  public relatedContent;

  constructor(
    protected companyService: CompanyService,
    public commonService: CommonService,
    public userService: UserService,
    protected listingService: ListingService
  ) {}

  ngOnInit(): void {
    this.loading = true;

    this.Subscriptions.push(
      this.userService.User.subscribe(data => (this.user = data.User))
    );
    this.getData();
  }

  getData() {
    const companySlug = window.location.pathname.split('/')[2];
    this.companyService.load(companySlug).then(company => {
      this.company = company;
      this.listingService
        .loadRelatedContent(this.company.product_id)
        .then(data => {
          this.relatedContent = data;
          this.loading = false;
        });
    }).catch(() => {
      this.navigate('/');
    });
  }

  public navigate(path) {
    window.location.href = path;
  }

  showProducts() {
    return this.company.filter !== 'club' || this.isPartOfTheGroup();
  }

  leaveClub() {
    this.companyService
      .clubStatus(this.company.id, 'leave')
      .then(() => window.location.reload());
  }

  joinClub() {
    this.companyService
      .clubStatus(this.company.id, 'join')
      .then(() => window.location.reload());
  }

  isPartOfTheGroup() {
    return this.user?.groups?.includes(this.company.Group.slug);
  }
}
